import React, { useContext } from "react";

import { AppContext } from "@component/AppProvider";
import i18n from "@lang/i18n";

export const Lang = () => {
    const { t } = useContext(AppContext);

    return (
        <div style={{ margin: 150 }}>
            <h3>다국어</h3>
            <h1>{t("hello")}</h1>
            <div style={{ marginTop: 10 }}>
                <button type="button" onClick={() => i18n.changeLanguage("en")} style={{ border: "black solid 1px" }}>
                    ENG
                </button>
                <button type="button" onClick={() => i18n.changeLanguage("ko")} style={{ marginLeft: 10, border: "black solid 1px" }}>
                    KOR
                </button>
            </div>
        </div>
    );
};

export { default as LinkTestPage } from "./Link";
